module.exports = __webpack_public_path__ + "img/pageinteriors_profesionales-independientes-y-pymes-02salud.6f45f40e.jpg";